import React from "react";

/** AI Overview / Quick Read sparkle icon (matches search results overview) */
const SparkleIcon = ({ className = "" }) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M12 2 L13.5 9 L20 10.5 L13.5 12 L12 19 L10.5 12 L4 10.5 L10.5 9 Z"
      fill="currentColor"
    />
    <path
      d="M19 2 L19.8 5.2 L23 6 L19.8 6.8 L19 10 L18.2 6.8 L15 6 L18.2 5.2 Z"
      fill="currentColor"
      opacity="0.7"
    />
  </svg>
);

export default SparkleIcon;
